/**
 * Identificador de sesion del carrito (Functional Design, Pregunta 6):
 * UUID generado en el primer uso, persistido en localStorage.
 */
const CLAVE = 'sacrafts_cart_session';

export function obtenerCartSessionId(): string {
  const existente = window.localStorage.getItem(CLAVE);
  if (existente) return existente;

  const nuevo = crypto.randomUUID();
  window.localStorage.setItem(CLAVE, nuevo);
  return nuevo;
}

export function reiniciarCartSessionId(): string {
  const nuevo = crypto.randomUUID();
  window.localStorage.setItem(CLAVE, nuevo);
  return nuevo;
}
